import { useEffect, useRef, useState } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import 'leaflet.markercluster';

// Fix for default markers in Leaflet with bundlers
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAApCAYAAADAk4LOAAAFgUlEQVR4Aa1XA5BjWRTN2oW17d3YaZtr2962HUzbXNfN1+3eRBozDpnOJgJAzWDZMAQgq4k3d5xA8sIoWZV5QZQQQ4iREIREiIRAJgn2nqXJQPpENHhhBXRBBEQEEeWQIaLi6ue899e95jfvv7Pmv/fwP85v5nPev3Pev9e59wH0A3AFhz8CwEgBcAOBvABqJoEoAJBIAJBhAFqNvwDAF8AL4A10LQB2cgfOUMv9P7RxA8wBwKvYQiGSh2bkgn6rvT8nTvIZIAAQ/PwKWL8Dwm2ZhO7oGgDjAAAA+P1vP4JyAKYAXgQA+Oj/k8kPwJCvbhNPOJmTlFMOk7eSpb3kn7tA6JJB+4kxnogxTfj5r7qEBxAEhvw8ALcB4AVQJwDgZWDgRwDgZgDwZwDQCwJoAAAFIIMEegCTswHPGODgFMAUOB0A7BdgsAPAx9VmQoqkB8RfSkCNhW8wAxI6egUAAPgFAV4C8E8kEi7J6zIZAKAF8LhCwFYB4EQA8HeCcwXA2QZJSM+BFqNSXwEAAFgBtAZcLQDwJQD0VABwNgD4j4D5APAcAPhrAOAJJJAGJtAJJH9jKhFRFEMd+Rjkuow2sAVdPdA8FXP8dQsqGvNfK1/nFDd3oKLM3TvCmI2c0JD9IePMfCsHvdBKP+S2rYYJcQCgwf2aBPxQTJI5yLWZWlYrjvN/tBdqUIB3EoKfKvJfJe7CzNAiXvA9LJkxZ2yxcojFtjcAmTHlFJGXbKWLkKJQr7nCAdVqnlkgLLJZ8BZ0A5hgzJdApRW7fQC0Y6RDQ7a7LIBrJz7FdARyFhYJcgR0yqBhJgMmhb1yVVc5n0bwZJM19C45OowNhXFvuaLVJoA7pSU3H3yEJ/kXCgKkH0fzjI3AmZvgN6OIEBK2Q1wCCVMZxQCzAkZt6h6MsKOawgI6P6AXCzAPEBJgDtCCAXgEBGgsAAmBA9EgAAnAOgEwGwBA2GA+BgAYBACi4FwDYAJgDJBG90AtgPBhNnO4VwAABBIBYw5DwAAkKcoBaEAAIgH+YBrCJ9R/M9wUAQqMBAGCGsEgGuTh4wAAGhJnYHgCzA2DQAQEQBkY6QDaYiYFkZWwygzMgAYH0CMeQAoSPsABPmGU1BBAS8B6QCChJ6tEi5GGAA5gAI+gkPgCBBQzNmOgCQQhDgDQGQAAWwGcCgKJ5QEOjAIcQACEDQKoIAOBYqgCCQGchDABOgEAIoAAjABBgAkCDJAJEFgCIHEE2gDBQAnDfyGwAiDAn2y0TZA1kWHoKv/WTXhIzMrjcO/dQhACf/+rUhBEhOjEFHHWrXiHoQBDCbNGmMc5wTwwA3+AANONhJC0YiCAgQ+qN6P5vADUoAgwj8qk5Hpw5oZbN+YGl9QGqFbHJ2QLRvMzpJGrG6LD9r1w1gkDBoQYMFX+BBgPiQOAABYHwMF2AoLjK6+gGmHsGHaGKCWAP1AqQNXQD2AelAjhABKiAc4AJQDc0ADQM8nV0AORNaAPQEaALQEaAPQEaAPQE6AAOgA6ADQM8nV0AORNaAPQEaALQEaAPQEaAPQE6AAOgA6ADQM8nV0AORNaAPQEaALQEaAPQEaAPQE6AAOgA6ABQD6gFIAPQCaBVHCMTjNV4AARdHpbpQxST4MKEpgJhSJ1SXUEK',
    iconUrl: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAApCAYAAADAk4LOAAAFgUlEQVR4Aa1XA5BjWRTN2oW17d3YaZtr2962HUzbXNfN1+3eRBozDpnOJgJAzWDZMAQgq4k3d5xA8sIoWZV5QZQQQ4iREIREiIRAJgn2nqXJQPpENHhhBXRBBEQEEeWQIaLi6ue899e95jfvv7Pmv/fwP85v5nPev3Pev9e59wH0A3AFhz8CwEgBcAOBvABqJoEoAJBIAJBhAFqNvwDAF8AL4A10LQB2cgfOUMv9P7RxA8wBwKvYQiGSh2bkgn6rvT8nTvIZIAAQ/PwKWL8Dwm2ZhO7oGgDjAAAA+P1vP4JyAKYAXgQA+Oj/k8kPwJCvbhNPOJmTlFMOk7eSpb3kn7tA6JJB+4kxnogxTfj5r7qEBxAEhvw8ALcB4AVQJwDgZWDgRwDgZgDwZwDQCwJoAAAFIIMEegCTswHPGODgFMAUOB0A7BdgsAPAx9VmQoqkB8RfSkCNhW8wAxI6egUAAPgFAV4C8E8kEi7J6zIZAKAF8LhCwFYB4EQA8HeCcwXA2QZJSM+BFqNSXwEAAFgBtAZcLQDwJQD0VABwNgD4j4D5APAcAPhrAOAJJJAGJtAJJH9jKhFRFEMd+Rjkuow2sAVdPdA8FXP8dQsqGvNfK1/nFDd3oKLM3TvCmI2c0JD9IePMfCsHvdBKP+S2rYYJcQCgwf2aBPxQTJI5yLWZWlYrjvN/tBdqUIB3EoKfKvJfJe7CzNAiXvA9LJkxZ2yxcojFtjcAmTHlFJGXbKWLkKJQr7nCAdVqnlkgLLJZ8BZ0A5hgzJdApRW7fQC0Y6RDQ7a7LIBrJz7FdARyFhYJcgR0yqBhJgMmhb1yVVc5n0bwZJM19C45OowNhXFvuaLVJoA7pSU3H3yEJ/kXCgKkH0fzjI3AmZvgN6OIEBK2Q1wCCVMZxQCzAkZt6h6MsKOawgI6P6AXCzAPEBJgDtCCAXgEBGgsAAmBA9EgAAnAOgEwGwBA2GA+BgAYBACi4FwDYAJgDJBG90AtgPBhNnO4VwAABBIBYw5DwAAkKcoBaEAAIgH+YBrCJ9R/M9wUAQqMBAGCGsEgGuTh4wAAGhJnYHgCzA2DQAQEQBkY6QDaYiYFkZWwygzMgAYH0CMeQAoSPsABPmGU1BBAS8B6QCChJ6tEi5GGAA5gAI+gkPgCBBQzNmOgCQQhDgDQGQAAWwGcCgKJ5QEOjAIcQACEDQKoIAOBYqgCCQGchDABOgEAIoAAjABBgAkCDJAJEFgCIHEE2gDBQAnDfyGwAiDAn2y0TZA1kWHoKv/WTXhIzMrjcO/dQhACf/+rUhBEhOjEFHHWrXiHoQBDCbNGmMc5wTwwA3+AANONhJC0YiCAgQ+qN6P5vADUoAgwj8qk5Hpw5oZbN+YGl9QGqFbHJ2QLRvMzpJGrG6LD9r1w1gkDBoQYMFX+BBgPiQOAABYHwMF2AoLjK6+gGmHsGHaGKCWAP1AqQNXQD2AelAjhABKiAc4AJQDc0ADQM8nV0AORNaAPQEaALQEaAPQEaAPQE6AAOgA6ADQM8nV0AORNaAPQEaALQEaAPQEaAPQE6AAOgA6ADQM8nV0AORNaAPQEaALQEaAPQEaAPQE6AAOgA6ABQD6gFIAPQCaBVHCMTjNV4AARdHpbpQxST4MKEpgJhSJ1SXUEK',
    shadowUrl: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApCAQAAAACach9AAACMUlEQVR4Ae3ShY7jQBAE0Aoz/f9/HTMzhg1zrdKUrJbdx+Kd2nD0VNiIiIiIiIiIiIiIiIiIiIhIXGemmPyDZCdJZBBBABDwcBAagEsNAQAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAgAOAQEOAAECAg'
});

function MapContainer({ 
    members, 
    config, 
    height, 
    onMarkerHover, 
    onMarkerHoverOut, 
    onBoundsChange, 
    registerMapInstance, 
    registerMarker, 
    unregisterMarker,
    isFavorite,
    onToggleFavorite,
    isPendingFavorite,
    isLoggedIn = true
}) {
    const mapRef = useRef(null);
    const mapInstanceRef = useRef(null);
    const markersRef = useRef(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!mapRef.current) return;

        // Initialize map
        const map = L.map(mapRef.current, {
            center: [
                config?.config?.center_lat || 40.7128,
                config?.config?.center_lng || -74.0060
            ],
            zoom: config?.config?.zoom_level || 10,
            scrollWheelZoom: false
        });

        // Add tile layer
        const tileStyle = config?.config?.tile_style || 'light';
        let tileUrl, attribution;

        switch (tileStyle) {
            case 'dark':
                tileUrl = 'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png';
                attribution = '© OpenStreetMap contributors © CARTO';
                break;
            case 'satellite':
                tileUrl = 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}';
                attribution = 'Tiles © Esri';
                break;
            default:
                tileUrl = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
                attribution = '© OpenStreetMap contributors';
        }

        L.tileLayer(tileUrl, { attribution,
  referrerPolicy: 'strict-origin-when-cross-origin' }).addTo(map);

        // Set up global event delegation for popup buttons
        // This handles both regular markers and clustered markers
        const handlePopupClick = (e) => {
            const target = e.target.closest('.popup-message-btn, .popup-profile-btn, .popup-favorite-btn');
            if (!target) return;

            e.preventDefault();
            e.stopPropagation();

            if (target.classList.contains('popup-message-btn')) {
                const recipientId = target.getAttribute('data-recipient-id');
                const recipientName = target.getAttribute('data-recipient-name');
                
                const event = new CustomEvent('openMessageModal', {
                    detail: { recipientId, recipientName }
                });
                window.dispatchEvent(event);
            } else if (target.classList.contains('popup-profile-btn')) {
                const profileUrl = target.getAttribute('data-profile-url');
                if (profileUrl) {
                    window.open(profileUrl, '_blank', 'noopener,noreferrer');
                }
            } else if (target.classList.contains('popup-favorite-btn')) {
                const userId = target.getAttribute('data-user-id');
                if (userId && !target.disabled && onToggleFavorite) {
                    onToggleFavorite(userId);
                }
            }
        };

        // Attach event listener to map container
        mapRef.current.addEventListener('click', handlePopupClick, true);

        // Enable scroll wheel zoom with focus
        map.on('focus', () => map.scrollWheelZoom.enable());
        map.on('blur', () => map.scrollWheelZoom.disable());

        // Create marker cluster group
        const markers = L.markerClusterGroup({
            chunkedLoading: true,
            maxClusterRadius: 80,
            spiderfyOnMaxZoom: true,
            showCoverageOnHover: false,
            zoomToBoundsOnClick: true,
            iconCreateFunction: function(cluster) {
                const count = cluster.getChildCount();
                let className = 'marker-cluster-small';
                
                if (count >= 100) {
                    className = 'marker-cluster-large';
                } else if (count >= 10) {
                    className = 'marker-cluster-medium';
                }
                
                return new L.DivIcon({
                    html: `<div><span>${count}</span></div>`,
                    className: `marker-cluster ${className}`,
                    iconSize: new L.Point(40, 40)
                });
            }
        });

        map.addLayer(markers);

        mapInstanceRef.current = map;
        markersRef.current = markers;
        
        // Register map instance with parent
        if (registerMapInstance) {
            registerMapInstance(map);
        }
        
        // Add bounds change listener
        if (onBoundsChange) {
            map.on('moveend', () => {
                const bounds = map.getBounds();
                const boundsObj = {
                    north: bounds.getNorth(),
                    south: bounds.getSouth(),
                    east: bounds.getEast(),
                    west: bounds.getWest()
                };
                onBoundsChange(boundsObj);
            });
        }
        
        setIsLoading(false);

        // Cleanup function
        return () => {
            if (mapRef.current) {
                mapRef.current.removeEventListener('click', handlePopupClick, true);
            }
            if (mapInstanceRef.current) {
                mapInstanceRef.current.remove();
                mapInstanceRef.current = null;
            }
        };
    }, [config, onToggleFavorite]);

    // Update markers when members change
    useEffect(() => {
        if (!markersRef.current || !members) return;

        // Clear existing markers
        markersRef.current.clearLayers();

        // Add new markers
        const validMembers = members.filter(member => 
            member.has_location && member.latitude && member.longitude
        );

        validMembers.forEach(member => {
            const marker = createMemberMarker(member);
            markersRef.current.addLayer(marker);
            
            // Register marker with parent for hover interactions
            if (registerMarker) {
                registerMarker(member.user_id, marker);
            }
        });

        // Fit map to markers if we have them
        if (validMembers.length > 0 && validMembers.length <= 100) {
            const group = new L.featureGroup(markersRef.current.getLayers());
            const bounds = group.getBounds();
            if (bounds.isValid()) {
                mapInstanceRef.current.fitBounds(bounds.pad(0.1));
            }
        }
    }, [members, config, registerMarker, isFavorite, isPendingFavorite, onToggleFavorite, isLoggedIn, onMarkerHover, onMarkerHoverOut]);

    const decodeHtmlEntities = (str) => {
        if (!str) return str;
        const textarea = document.createElement('textarea');
        textarea.innerHTML = str;
        return textarea.value;
    };

        const createMemberMarker = (member) => {
        // Create custom icon with marker_icon (fallback to avatar_url for compatibility)
        const markerIconUrl = member.marker_icon || member.avatar_url;
        const iconHtml = `
            <div class="member-marker" data-user-id="${member.user_id}">
                <img src="${markerIconUrl}" alt="${decodeHtmlEntities(member.display_name)}" 
                     class="marker-avatar" 
                     onerror="this.src='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiNjY2MiLz4KPGNpcmNsZSBjeD0iMjAiIGN5PSIxNiIgcj0iNiIgZmlsbD0iI2ZmZiIvPgo8cGF0aCBkPSJNMzAgMzJjMC01LjUyMy00LjQ3Ny0xMC0xMC0xMHMtMTAgNC40NzctMTAgMTAiIGZpbGw9IiNmZmYiLz4KPC9zdmc+'" />
            </div>
        `;


        const customIcon = L.divIcon({
            html: iconHtml,
            className: 'custom-member-marker',
            iconSize: [40, 40],
            iconAnchor: [20, 40],
            popupAnchor: [0, -40]
        });

        const marker = L.marker([member.latitude, member.longitude], {
            icon: customIcon,
            title: decodeHtmlEntities(member.display_name)
        });

        // Determine if we're using avatar as cover image based on form config (same as OptimizedMemberCard)
        const formConfig = config?.config || config || {};
        const coverImageSource = formConfig.cover_image_source || 'bp_cover';
        const isUsingAvatarAsCover = coverImageSource === 'bp_avatar';
        
        // Create popup content - use cover_image for popup (fallback to avatar_url for compatibility)
        // Guard: some plugins store the field value as an HTML <img> tag — extract the src if so
        const extractUrlFromHtml = (val) => {
            if (val && val.includes('<img')) {
                const m = val.match(/src=["']([^"']+)["']/);
                return m ? m[1] : '';
            }
            return val;
        };
        const coverImageUrl = extractUrlFromHtml(member.cover_image) || member.avatar_url;
        let popupContent = `
            <div class="member-popup">
                <div class="popup-cover-header ${isUsingAvatarAsCover ? 'avatar-as-cover' : ''}">
                    <img src="${coverImageUrl}" alt="${decodeHtmlEntities(member.display_name)}" class="member-cover-image ${isUsingAvatarAsCover ? 'is-avatar' : ''}">
                </div>
                <div class="popup-content">
                    <div class="member-name">${decodeHtmlEntities(member.display_name)}</div>
        `;

        if (member.display_fields?.length > 0) {
            // Filter fields that should show in popup
            const popupFields = member.display_fields.filter(field => field.show_in_popup !== false);
            
            if (popupFields.length > 0) {
                popupContent += '<div class="member-fields">';
                popupFields.forEach(field => {
                    if (field.value) {
                        let fieldValue;
                        const hideLabel = field.hide_label || false;
                        
                        // Handle custom formatted fields (admin-set HTML content)
                        if (field.type === 'custom_format') {
                            // For custom formatted fields, use the value as-is (it's already safe HTML)
                            fieldValue = field.value;
                        } else {
                            // For regular fields, decode HTML entities
                            fieldValue = Array.isArray(field.value) 
                                ? field.value.map(v => decodeHtmlEntities(v)).join(', ') 
                                : decodeHtmlEntities(field.value);
                        }
                        
                        popupContent += `
                            <div class="member-field" data-field-id="${field.field_id}" id="popup-member-${member.user_id}-field-${field.field_id}">
                                ${hideLabel ? '' : `<span class="field-label">${decodeHtmlEntities(field.label)}:</span> `}${fieldValue}
                            </div>
                        `;
                    }
                });
                popupContent += '</div>';
            }
        }

        if (member.profile_url) {
            popupContent += '<div class=\"member-actions\">';
            
            // Always show profile button
            popupContent += `
                <button 
                    class=\"base-btn profile-btn btn-icon btn-outline popup-profile-btn\" 
                    data-profile-url=\"${member.profile_url}\"
                    title=\"View ${decodeHtmlEntities(member.display_name).replace(/\"/g, '&quot;')}'s profile\"
                >
                    <svg class=\"profile-icon\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"currentColor\">
                        <path d=\"M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z\"/>
                    </svg>
                </button>
            `;
            
            // Only show message and favorite buttons if user is logged in
            if (isLoggedIn) {
                const memberIsFavorite = isFavorite(member.user_id);
                const memberIsPending = isPendingFavorite(member.user_id);
                
                popupContent += `
                    <button 
                        class="base-btn message-btn btn-icon btn-outline popup-message-btn" 
                        data-recipient-id="${member.user_id}" 
                        data-recipient-name="${decodeHtmlEntities(member.display_name).replace(/"/g, '&quot;')}"
                        title="Send message to ${decodeHtmlEntities(member.display_name).replace(/"/g, '&quot;')}"
                    >
                        <svg class="message-icon" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16Z"/>
                            <path d="M7 9H17V11H7V9Z"/>
                            <path d="M7 12H13V14H7V12Z"/>
                        </svg>
                    </button>
                    <button 
                        class="base-btn favorite-btn btn-icon btn-outline popup-favorite-btn ${memberIsFavorite ? 'favorited' : ''} ${memberIsPending ? 'pending' : ''}" 
                        data-user-id="${member.user_id}"
                        title="${memberIsPending ? (memberIsFavorite ? 'Removing from favorites...' : 'Adding to favorites...') : (memberIsFavorite ? 'Remove from favorites' : 'Add to favorites')}"
                        ${memberIsPending ? 'disabled' : ''}
                    >
                `;
                
                if (memberIsPending) {
                    popupContent += `
                        <svg class="favorite-loading" width="14" height="14" viewBox="0 0 24 24" fill="none">
                            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-dasharray="32" stroke-dashoffset="32">
                                <animate attributeName="stroke-dasharray" dur="2s" values="0 32;16 16;0 32;0 32" repeatCount="indefinite" />
                                <animate attributeName="stroke-dashoffset" dur="2s" values="0;-16;-32;-32" repeatCount="indefinite" />
                            </circle>
                        </svg>
                    `;
                } else {
                    popupContent += `
                        <svg class="favorite-icon" width="14" height="14" viewBox="0 0 24 24" fill="${memberIsFavorite ? 'currentColor' : 'none'}" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                        </svg>
                    `;
                }
                
                popupContent += `
                    </button>
                `;
            }
            
            popupContent += '</div></div>';
        }

        popupContent += '</div></div>'; // Close popup-content and member-popup
        marker.bindPopup(popupContent);

        // Add event listeners for hover functionality
        marker.on('popupopen', () => {
            if (onMarkerHover) {
                onMarkerHover(member);
            }
        });
        
        marker.on('popupclose', () => {
            if (onMarkerHoverOut) {
                onMarkerHoverOut();
            }
        });

        return marker;
    };

    return (
        <div className="map-container" style={{ height }}>
            {isLoading && (
                <div className="map-loading">
                    <div>Loading map...</div>
                </div>
            )}
            <div ref={mapRef} className="leaflet-map" style={{ height: '100%' }} />
        </div>
    );
}

export default MapContainer;
